import { ClientEvent, MatrixClient, MatrixEvent } from 'matrix-js-sdk/src/matrix';

import { getSoundMutedRoomIds } from 'modules/Messenger/components/MessengerView/MessengerSidebar/useMessengerRoomSoundMute';

const PUSH_RULES_EVENT_TYPE = 'm.push_rules';

type Listener = () => void;

let snapshot: Set<string> = new Set();
let hydratedClient: MatrixClient | null = null;
let accountDataHandler: ((event: MatrixEvent) => void) | null = null;
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

const detachCurrentListener = () => {
  if (hydratedClient && accountDataHandler) {
    hydratedClient.off(ClientEvent.AccountData, accountDataHandler);
  }
  hydratedClient = null;
  accountDataHandler = null;
};

const getSnapshot = (): Set<string> => snapshot;

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const setMuted = (roomId: string, muted: boolean): void => {
  const alreadyMuted = snapshot.has(roomId);
  if (muted === alreadyMuted) return;
  const next = new Set(snapshot);
  if (muted) next.add(roomId);
  else next.delete(roomId);
  snapshot = next;
  notify();
};

const hydrate = (matrixClient: MatrixClient): void => {
  if (hydratedClient === matrixClient) return;
  detachCurrentListener();
  hydratedClient = matrixClient;
  snapshot = getSoundMutedRoomIds(matrixClient);

  accountDataHandler = (event: MatrixEvent) => {
    if (event.getType() !== PUSH_RULES_EVENT_TYPE) return;
    const next = getSoundMutedRoomIds(matrixClient);
    snapshot = next;
    notify();
  };
  matrixClient.on(ClientEvent.AccountData, accountDataHandler);
  notify();
};

const reset = (): void => {
  detachCurrentListener();
  snapshot = new Set();
  listeners.clear();
};

const soundMuteStore = {
  getSnapshot,
  subscribe,
  setMuted,
  hydrate,
  reset,
};

export default soundMuteStore;
